import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { getProduct, categoryTitle, relatedProducts } from '../utils/products';
import { ProductGallery } from '../components/product/ProductGallery';
import { BuyBox } from '../components/product/BuyBox';
import { ProductDetails } from '../components/product/ProductDetails';
import { ProductSection } from '../components/shop/ProductSection';
import { NotFound } from './NotFound';
export function Product() {
  const {
    slug = ''
  } = useParams();
  const product = getProduct(slug);
  if (!product) return <NotFound data-id="element-502" data-mp="3imckj4upas8k" />;
  return <div className="pb-24 lg:pb-0" data-id="element-503" data-mp="3nl5xmw62sh87">
      <div className="mx-auto max-w-7xl px-5 pt-8 lg:px-8 lg:pt-10" data-id="element-504" data-mp="3nk4jgitrjem9">
        <nav aria-label="Kruimelpad" className="text-sm text-muted" data-id="element-505" data-mp="3sbmbuihq06vm">
          <Link to="/" className="hover:text-ink" data-id="element-506" data-mp="3sdz1lhtpzlj8">Home</Link>
          <span className="mx-2" data-id="element-507" data-mp="2uvfda5duoj3n">/</span>
          <Link to={`/collectie/${product.category}`} className="hover:text-ink" data-id="element-508" data-mp="2uunvbxd6ejvu">{categoryTitle(product.category)}</Link>
          <span className="mx-2" data-id="element-509" data-mp="n6xfmfj67qul">/</span>
          <span className="text-ink" data-id="element-510" data-mp="n5vs3bkyxbvz">{product.name}</span>
        </nav>
        <div className="mt-6 grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-511" data-mp="i7kj132hz5et">
          <div className="lg:col-span-7" data-id="element-512" data-mp="iaghqtm65y4b">
            <div className="lg:sticky lg:top-36" data-id="element-513" data-mp="dgc7a0dp37yh">
              <ProductGallery key={product.slug} product={product} data-id="element-514" data-mp="df14o3vzk68y" />
            </div>
          </div>
          <div className="lg:col-span-5" data-id="element-515" data-mp="8ggbupj2couj">
            <BuyBox key={product.slug} product={product} data-id="element-516" data-mp="4hqrue3is91x" />
          </div>
        </div>
      </div>
      <ProductDetails key={product.slug} product={product} data-id="element-517" data-mp="3vmqrui6gyg5u" />
      <div className="border-t border-line" data-id="element-518" data-mp="3qnxfwu6tyx7s">
        <ProductSection title="Maak het ritueel compleet" products={relatedProducts(product)} data-id="element-519" data-mp="3qoyv9auvq5vb" />
      </div>
    </div>;
}